import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinkIcon from '@material-ui/icons/Link';

import { isValidHttpUrl } from '../../../Utils/engine/triggerApi';

const useStyles = makeStyles({
  root: {
    marginTop: 10,
    marginBottom: 8,
  },
});

/**
 * Champ de saisie de l'URL de base de test des champs dynamiques.
 * La valeur n'est transmise au parent qu'à la validation (perte du focus ou
 * touche Entrée) et seulement si elle est vide ou si c'est une URL http(s)
 * valide, pour éviter de relancer les appels API à chaque frappe.
 */
const NeoTestBaseUrl = ({ value, onChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const trimmedValue = localValue.trim();
  const isInvalid = trimmedValue !== '' && !isValidHttpUrl(trimmedValue);

  const commit = () => {
    if (!isInvalid && trimmedValue !== (value || '')) {
      onChange(trimmedValue);
    }
  };

  return (
    <TextField
      fullWidth
      className={classes.root}
      error={isInvalid}
      helperText={
        isInvalid
          ? t('NeoBuilder.TestBaseUrl.Invalid')
          : t('NeoBuilder.TestBaseUrl.Helper')
      }
      id='neo-test-base-url'
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <LinkIcon fontSize='small' />
          </InputAdornment>
        ),
      }}
      label={t('NeoBuilder.TestBaseUrl.Label')}
      placeholder='https://url-test.fr'
      size='small'
      value={localValue}
      variant='outlined'
      onBlur={commit}
      onChange={(e) => setLocalValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          commit();
        }
      }}
    />
  );
};

NeoTestBaseUrl.defaultProps = {
  value: '',
};

NeoTestBaseUrl.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default NeoTestBaseUrl;
